import { IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from '@material-ui/core';
import {
  VisibilityOff,
  Visibility,
  Group as GroupIcon,
  KeyboardArrowUp,
  KeyboardArrowDown,
  AddCircle
} from '@material-ui/icons';
import React, { useState } from 'react';
import { cubeRepository } from '../../../Domain/Repositories/CubeRepository';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import Loading from "../../UiComponents/Loading";
import {TrafficShapingStatus} from "../../../Domain/Models/TrafficShapingStatus";
import Cube from "../../../Domain/Models/Cube";
import Group from "../../../Domain/Models/Group";
import DecisionModal from "../../UiComponents/DecisionModal";
import {QueueLineService} from "../../../Domain/Services/QueueLineService";
import QueueListRow from "./QueueListRow";
import {TrafficShapingService} from "../../../Domain/Services/TrafficShapingService";
import PredefinedRouteModal from "../PredefinedRoutes/PredefinedRouteModal";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));

export interface KickedGroupListProps
{
  trafficShapingStatus?: TrafficShapingStatus;
  errorCardController: React.RefObject<ErrorCardController>;
  forceUpdate: () => void;
}

export default function KickedGroupList(props: KickedGroupListProps)
{
  const classes = useStyles();
  const { trafficShapingStatus, errorCardController, forceUpdate } = props;

  const [idVisible, setIdVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [decisionDialogOpen, setDecisionDialogOpen] = useState(false);
  const [groupToAdd, setGroupToAdd] = useState<Group>();

  const handleDialogClose = () =>
  {
    setGroupToAdd(undefined);
    setDecisionDialogOpen(false);
  };

  const handleAddToDtrs = (group: Group) =>
  {
    setGroupToAdd(group);
    setDecisionDialogOpen(true);
  }

  const handleDecisionAccepted = () =>
  {
    handleDialogClose();
    setLoading(true);
    
    if (groupToAdd === undefined)
    {
      return;
    }

    TrafficShapingService.addGroup(groupToAdd.id)
      .then(() =>
      {
        setLoading(false);
        forceUpdate();
      })
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardController.current?.addErrorMessage(e.message)
      });
  }

  return (
      <>
        {groupToAdd !== undefined && (
          <>
            <DecisionModal
              open={decisionDialogOpen}
              message={`Add ${groupToAdd.playerPairs.map(x => x.name).join(' vs. ')} to DTRS?`}
              onAccept={handleDecisionAccepted}
              onCancel={handleDialogClose}
            />
          </>
        )}
        
        <Paper className={classes.paper}>
          <Toolbar>
            <Typography className={classes.title} component="h2" variant="h6" color="primary" gutterBottom>
              Kicked Groups
            </Typography>
            <IconButton size="small" color="default" onClick={() => setIdVisible(!idVisible)}>
              {idVisible ? <VisibilityOff/> : <Visibility/>}
            </IconButton>
          </Toolbar>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {idVisible && <TableCell>ID</TableCell>}
                  <TableCell>Group Name</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {trafficShapingStatus?.kickedGroups?.map((row) => (
                  <TableRow key={row.id} hover>
                    {idVisible && <TableCell scope="row">{row.id}</TableCell>}
                    <TableCell>{row.playerPairs.map(x => x.name).join(' vs. ')}</TableCell>
                    <TableCell>
                      <IconButton size="small" color="default" onClick={() => handleAddToDtrs(row)}>
                        <AddCircle/>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Paper>
      </>
  );
}